import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HeroSection from '../components/home/HeroSection.jsx';
import FeaturedProducts from '../components/home/FeaturedProducts.jsx';
import CategoriesShowcase from '../components/home/CategoriesShowcase.jsx';
import PromotionalBanner from '../components/home/PromotionalBanner.jsx';
import LatestArrivals from '../components/home/LatestArrivals.jsx';
import WhyChooseUs from '../components/home/WhyChooseUs.jsx';
import Newsletter from '../components/home/Newsletter.jsx';

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  const mainRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Hero section animation
      gsap.from('.hero-content', {
        opacity: 0,
        y: 50,
        duration: 1,
        delay: 0.3,
      });

      // Section animations
      const sections = ['.featured-section', '.categories-section', '.why-choose-section'];
      sections.forEach((section) => {
        gsap.from(section, {
          scrollTrigger: {
            trigger: section,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
          opacity: 0,
          y: 50,
          duration: 1,
        });
      });
    }, mainRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={mainRef}>
      <HeroSection />
      <FeaturedProducts />
      <PromotionalBanner />
      <CategoriesShowcase />
      <LatestArrivals />
      <WhyChooseUs />
      <Newsletter />
    </div>
  );
};

export default HomePage;